export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./i18n.vue?vue&type=template&id=8c6e1042&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Settings/i18n.vue?vue&type=template&id=8c6e1042&
// module id = null
// module chunks = 